import { EspaceSelectors } from '@get/store/selectors';
import { SelectorModel } from '@get/utils';

// tslint:disable-next-line: variable-name
export const EspaceModel: SelectorModel = {
  name: 'espaces',
  getSelector: EspaceSelectors.selectAllEspacesDictionary,
  isReady: EspaceSelectors.selectIsReadyEspace
};
